// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2asC5","footer":"ModalFilter_footer__1XYiR"};